import React from "react";
import styled from "styled-components";
// import { NavLink } from "react-router-dom";
// import { Button } from "../styles/Button";
// import { FaDiscord, FaInstagram, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <Wrapper>
        {/*<section className="contact-short">*/}
        {/*  <div className="grid grid-two-column">*/}
        {/*    <div>*/}
        {/*      <h3>Ready to get started?</h3>*/}
        {/*      <h3>Talk to us today</h3>*/}
        {/*    </div>*/}

        {/*    <div>*/}
        {/*      <Button className="btn hireme-btn">*/}
        {/*        <NavLink to="/contact"> Get Started </NavLink>*/}
        {/*      </Button>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</section>*/}
        {/* footer section */}

        <footer>
          <div className="container grid grid-four-column">
            <div className="footer-about">
              <h3><strong>SixthSens AI</strong></h3>
              <p>Empowering AI Innovation, Through Our AI Marketplace.</p>
            </div>

            {/*<div className="footer-contact">*/}
            {/*  <h3>Call Us:</h3>*/}
            {/*  <pre><strong>+91 9451103575</strong></pre>*/}
            {/*  <br/><br/>*/}
            {/*  <h3>Mail Us:</h3>*/}
            {/*  <pre><strong>contact@sixthsens.ai</strong></pre>*/}
            {/*</div>*/}
            {/*<div className="footer-contact">*/}
            {/*  <h3>Visit Us:</h3>*/}
            {/*  <pre><strong>{'2319P\n' +*/}
            {/*      'Sector 57, Sushant Lok 2,\n' +*/}
            {/*      'Gurugram, India - 122413\n' +*/}
            {/*      ''}</strong></pre>*/}
            {/*</div>*/}

          </div>

          <div className="footer-bottom--section">
            <hr />
            <div className="container grid grid-one-column ">
              <p>
                @{new Date().getFullYear()} © Copyright <strong>SixthSensAI</strong> (reg as <strong>Aabhas Gurukuls LLP</strong>). All Rights Reserved

              </p>
              <div>
                {/*<p>PRIVACY POLICY</p>*/}
                {/*<p>TERMS & CONDITIONS</p>*/}
              </div>
            </div>
          </div>
        </footer>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.section`
  .iSIFGq {
    margin: 0;
  }

  .contact-short {
    max-width: 60vw;
    margin: auto;
    padding: 5rem 10rem;
    background-color: ${({ theme }) => theme.colors.bg};
    border-radius: 1rem;
    box-shadow: ${({ theme }) => theme.colors.shadowSupport};
    transform: translateY(50%);

    .grid div:last-child {
      justify-self: end;
      align-self: center;
    }
  }

  footer {
    padding: 3rem 0 0rem 0;
    background-color: ${({ theme }) => theme.colors.footer_bg};
    h3 {
      color: ${({ theme }) => theme.colors.hr};
      margin-bottom: 2.4rem;
    }
    pre {
      color: white;
      
      margin-bottom: 0rem;
      font-size: 1.7rem;
    }
    p {
      color: ${({ theme }) => theme.colors.white};
    }
    .footer-social--icons {
      display: flex;
      gap: 2rem;

      div {
        padding: 1rem;
        border-radius: 0%;
        border: 2px solid ${({ theme }) => theme.colors.white};

        .icons {
          color: ${({ theme }) => theme.colors.white};
          font-size: 2.4rem;
          position: relative;
          cursor: pointer;
        }
      }
    }
  }

  .footer-bottom--section {
    padding-top: 2rem;

    hr {
      margin-bottom: 2rem;
      color: ${({ theme }) => theme.colors.hr};
      height: 0.1px;
    }
  }

  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    .contact-short {
      max-width: 80vw;
      margin: 4.8rem auto;
      transform: translateY(0%);
      text-align: center;

      .grid div:last-child {
        justify-self: center;
      }
    }

    footer {
      padding: 2rem 0 2rem 0;
    }

    .footer-bottom--section {
      padding-top: 2rem;
    }
  }
`;

export default Footer;
